import React, { createContext, useContext, useState } from "react";

const ProfileImageContext = createContext();

export const ProfileImageProvider = ({ children }) => {
    const [profileImage, setProfileImage] = useState(null); // This will now store the File/Blob

    const saveProfileImage = (file) => {
        setProfileImage(file); // Store the binary file directly
    };

    const clearProfileImage = () => setProfileImage(null);

    return (
        <ProfileImageContext.Provider value={{ profileImage, saveProfileImage, clearProfileImage }}>
            {children}
        </ProfileImageContext.Provider>
    );
};

export const useProfileImage = () => useContext(ProfileImageContext); 